(function ($, undefined) {
	'use strict';

	const isDev = ($("html").attr("data-is-dev") === 'true' || window.location.hostname.match('.mg2proj'));

	// Test pipelines
	const PIPELINES = {
        ecommerce: {
            id: isDev ? "2908461" : "2400220",
            stages: {
                abandoned: isDev ? "2908462" : "2400227",
                current: isDev ? "2908463" : "2400227",
                paid: isDev ? "2908464" : "2400332",
                canceled: isDev ? "2908465" : "2400333",
            }
        }
    };

	const ACTION = "/action/hubspot";

	const TYPES = {
		"ASSOCIATION": "association",
		"DEAL": "deal",
		"CONTACT": "contact",
		"COMPANY": "company",
		"LINE_ITEM": "line_item"
	};

	// définis ici: https://legacydocs.hubspot.com/docs/methods/crm-associations/crm-associations-overview
	const ASSOCIATION_TYPES = {
		"CONTACT_TO_COMPANY": 1,
		"LINE_ITEM_TO_DEAL": 20,
	};

	const REGEX_DOMAINS_TO_IGNORE = [
		/^gmail\..*?$/i,
		/^yahoo\..*?$/i,
		/^live\..*?$/i,
		/^hotmail\..*?$/i,
		/^icloud\..*?$/i,
		/^outlook\..*?$/i,
		/^yandex\..*?$/i,
		/^aol\..*?$/i,
		/^gmx\..*?$/i,
	];

	const EMAIL_LISTS = {
		"JOB_OFFERS": isDev ? 9894684 : 8456155,
		"MARKETING_INFORMATION": isDev ? 9894736 : 7974909,
	};

	const ABANDONED_CART_URL = $("body").attr("abandoned-cart-url");
	const DEAL_NAME = $("html").attr("lang") == "fr" ? "Panier PMI Montr�al" : "PMI Montreal Cart";
    
    let pmiAccountEmail = $("body").attr("data-logged-pmi-account-email");
    let pmiAccountName = $("body").attr("data-logged-pmi-account-name");
    
    $(window).ready(() => {
        // Double check account info
        if (!pmiAccountEmail) {
            pmiAccountEmail = $("body").attr("data-logged-pmi-account-email");
        }
        if (!pmiAccountName) {
            pmiAccountName = $("body").attr("data-logged-pmi-account-name");
        }
    });

	function isActive() {
		return !$("body").attr("data-avoid-hubspot");
	}

	function domainFromEmail(email = "") {
		return email.split('@')[1];
	}

	function nameFromDomain(domain = "") {
		let lastDotIndex = domain.lastIndexOf('.');
		return domain.charAt(0).toUppercase() + domain.substring(1, lastDotIndex);
	}

	function addContact(email, phone, callback = () => { }) {
		phone = phone.length == 0 ? undefined : phone;
		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				type: TYPES.CONTACT,
				data: JSON.stringify({
					email: email,
					phone: phone
				})
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	}

	function addFullContact(email, phone, firstname, lastname, pmi_number, hs_language, callback = () => { }) {
		phone = phone.length == 0 ? undefined : phone;
		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				type: TYPES.CONTACT,
				data: JSON.stringify({
					email,
					phone,
					firstname,
					lastname,
					pmi_number,
					hs_language
				})
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	}

	function addAssociation(to, from, callback = () => {}, associationType = ASSOCIATION_TYPES.CONTACT_TO_COMPANY) {
		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				type: TYPES.ASSOCIATION,
				to,
				from,
				association: associationType
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	} 

	function deleteAssociation(to, from, callback = () => {}, associationType = ASSOCIATION_TYPES.CONTACT_TO_COMPANY) {
		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				type: TYPES.ASSOCIATION,
				to,
				from,
				association: associationType,
				delete: true
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	};
	
	function addDeal(name, contactId, abandonedCartUrl, pipeline, stage, customProperties, callback = () => {}) {

		let properties = [
			{
				"name": "dealname",
				"value": `${name}`,
			},
			{
				"name": "pipeline",
				"value": pipeline,
			},
			{
				"name": "dealstage",
				"value": stage
			}
		];
        
        if (customProperties) {
            for (var p in customProperties) {
                if (customProperties.hasOwnProperty(p)) {
                    properties.push({
                        "name": p,
                        "value": customProperties[p]
                    });
                }
            }
        }

		// if (abandonedCartUrl) {
		// 	properties.push({
		// 		"name": "ip__ecomm_bridge__abandoned_cart_url",
		// 		"value": abandonedCartUrl
		// 	});
		// }

		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				type: TYPES.DEAL,
				data: JSON.stringify({
					associations: {
						associatedVids: [contactId],
					},
					properties
				}),
                addPMIPaymentAmount: true
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	}

	function editDealStage(dealId, stage, callback = () => {}) {
		let properties = [
			{
				"name": "dealstage",
				"value": stage
			}
		];

		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
                type: TYPES.DEAL,
				dealId: dealId,
				data: JSON.stringify({
					properties
				})
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	}
    
    function editDealName(id, name, callback = () => {}) {
        let properties = [
			{
				"name": "dealname",
				"value": name
			}
		];

		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
                type: TYPES.DEAL,
				dealId: id,
				data: JSON.stringify({
					properties
				}),
                addPMIPaymentAmount: true
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
    }
    
    function updateDealAmount(id, callback = () => {}) {
        return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
                type: TYPES.DEAL,
				dealId: id,
				data: JSON.stringify({
					properties: []
				}),
                addPMIPaymentAmount: true
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
    }

	function createLineItem(hsProductId, quantity = 1, cartItemId, callback = () => {}) {
		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				type: TYPES.LINE_ITEM,
				hsProductId,
                quantity,
                cartItemId
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	}
    
	function editLineItemQuantity(lineItemId, quantity = 1, cartItemId, callback = () => {}) {
		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				type: TYPES.LINE_ITEM,
				lineItemId,
                quantity,
                cartItemId
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	}
    
	function deleteLineItem(lineItemId, callback =() => {}) {
		return $.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				type: TYPES.LINE_ITEM,
				lineItemId: lineItemId,
                delete: true
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	}

	function findContactByEmail(email, callback = () => {}) {
		return $.ajax({
			url: ACTION,
			type: 'GET',
			data: {
				type: TYPES.CONTACT,
				find: true,
				email
			},
            dataType: 'text',
			complete: (response, status) => callback(response.responseText, status, response)
		});
	}

	function parseResToJSON(res) {
		try {
			return JSON.parse(res);
		} catch (ex) {
			return res;
		}
	}

	// Other possible values: 
		// Member
		// PMI Account id
		// Certified PMP
		// Student
	function addContactToHubspot(form, callback = () => { }) {
		let contactId;
		let email = form.find('[name="email"]').val();
		let phone = form.find('[name="phoneNumber"]').val();
		let firstname = form.find('[name="firstName"]').val();
		let lastname = form.find('[name="lastName"]').val();
		let pminumber = form.find('[name="pmiNumber"]').val();
		let preferredLang = form.find('[name=preferredLanguage]').val();

		if(isActive()) {
			addFullContact(email, phone, firstname, lastname, pminumber, preferredLang, (res, status, jqXHR) => {
				let json = parseResToJSON(res);
				if (json && json.ok) {
					callback(res);
				} else if (jqXHR.status === 204) {
					findContactByEmail(email, callback);
				}
			});
		} else {
			callback();
		}
	}

	function cancelHubspotDeal(dealId, callback = () => {}) {
		editDealStage(dealId, PIPELINES.ecommerce.stages.canceled, function() {
			updateDealIdInSavedCart("", function() {
				$("body").removeAttr("data-hubspot-current-deal-id");
				callback();
			});
		});
	}

	function createOrUpdateHubspotDeal(hsProductId, quantity = 1, cartItemId, extraDealInfo, callback = () => {}) {
        let dealId = $("body").attr("data-hubspot-current-deal-id");
		if (!dealId) {
			findContactByEmail(pmiAccountEmail, (response) => {
                try {
                    const data = JSON.parse(response).result.data;
                    if (!data.vid) {
                        // if the contact does not exist do not create a deal (old accounts)
                        throw "Error Contact not found";
                    }
                    // Changer le nom du panier (actuellement PMI Montreal + date) par : Nom du contact + total pay� de la facture client
                    // Before: DEAL_NAME + ' ' + Fw.component.models().utils.formatISODate(new Date())
                    // Now: Account name + ' ' + current_time
                    addDeal(`${pmiAccountName} ${Fw.component.models().utils.formatISODate(new Date())}`,
                        data.vid,
                        ABANDONED_CART_URL,
                        PIPELINES.ecommerce.id,
                        PIPELINES.ecommerce.stages.current,
                        extraDealInfo,
                        (response) => {
                            var dealId = JSON.parse(response).result.data.dealId;
                            $("body").attr("data-hubspot-current-deal-id", dealId);
                            if (hsProductId && hsProductId.indexOf("TODO") === -1) {
                                createLineItemAndAddToDeal(hsProductId, quantity, dealId, cartItemId, () => {});
                            }
                            updateDealIdInSavedCart(dealId, callback);
                        }
                    );
                } catch (err) {
                    // Error finding contact with the email
                    callback();
                }
			});
		}
		else if (hsProductId && hsProductId.indexOf("TODO") === -1) {
            let $cartItem = $(".cart-popup-item[data-hs-product-id=" + hsProductId + "]");
            let lineItemId = $cartItem.attr("data-hs-line-item-id");
            if (quantity > 0) {
                // Add
                if (!lineItemId) {
                    // Create line item
                    createLineItemAndAddToDeal(hsProductId, quantity, dealId, cartItemId);
                } else {
                    // Update quantity in existing line item
                    editLineItemQuantity(lineItemId, quantity, cartItemId);
                }
            } else {
                // Remove
                deleteLineItem(lineItemId);
            }
            // Update deal amount
            updateDealAmount(dealId, callback);
		}
        else {
            callback();
        }
	}

	function updateDealIdInSavedCart(dealId, callback = () => {}) {
		let data = {
			ajax: true,
			extraField: dealId,
		};
		$.ajax({
			url: '/action/shopAddCart',
			type: 'POST',
			data: data,
			cache: false,
            dataType: 'text',
			complete: ({ responseText }) => {
				$("body").attr("data-hubspot-current-deal-id", dealId);
				callback(responseText);
			}
		});
	}

	function addContactsToList(vids, listId, callback = () => {}) {
		if (typeof vids !== "object") { vids =  [vids];}

		let data = {
			"vids": vids,
		};
		$.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				endpoint: `/contacts/v1/lists/${listId}/add`,
				method: "POST",
				data: JSON.stringify(data)
			},
			complete: ({responseText}) => {
				callback(responseText);
			}
		});
	}

	function removeContactFromList(vid, listId, callback = () =>{}) {
		let data = {
			"vids": [vid],
		};
		$.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				endpoint: `/contacts/v1/lists/${listId}/remove`,
				method: "POST",
				data: JSON.stringify(data)
			},
			complete: ({responseText}) => {
				callback(responseText);
			}
		});
	}

	// Si on opt-out un contact d'une liste on ne peut pas le re-optin, 
	// donc j'ai trouvé la solution de mettre NOT_OPTED au lieu de OPT_OUT, � voir si ça cause problème
	function updateEmailSubscriptionToHubspotList(email, isSubscribed, listId, callback = () =>{}) {
		let data = {
			"subscriptionStatuses": [
				{
					"id": listId,
					"optState": isSubscribed ? "OPT_IN" : "NOT_OPTED"
				}
			]
		};
		if (isSubscribed) {
			data.subscriptionStatuses.subscribed = true;
		}
		$.ajax({
			url: ACTION,
			type: 'POST',
			data: {
				endpoint: `/email/public/v1/subscriptions/${email}`,
				method: "PUT",
				data: JSON.stringify(data)
			},
			complete: ({responseText}) => {
				callback(responseText);
			}
		});
	}

	function toggleOptInsHubspotByContactEmail(contactEmail, marketingNewsletterValue, jobsNewsletterValue, callback = () => {}) {
		var doneCount = 0;

		var _complete = function() {
			doneCount++;

			if (doneCount === 2) {
				callback();
			}
		};

		updateEmailSubscriptionToHubspotList(contactEmail, marketingNewsletterValue, EMAIL_LISTS.MARKETING_INFORMATION, _complete);
		updateEmailSubscriptionToHubspotList(contactEmail, jobsNewsletterValue, EMAIL_LISTS.JOB_OFFERS, _complete);
	};

	function createLineItemAndAddToDeal(hsProductId, quantity, dealId, cartItemId, callback = () => {}) {
		createLineItem(hsProductId, quantity, cartItemId, (response) => {
			let json = parseResToJSON(response);
			if (json && json.ok) {
				let lineItemId = json.result.data.id;
				addAssociation(dealId, lineItemId, callback, ASSOCIATION_TYPES.LINE_ITEM_TO_DEAL);
                // Set lineItemId to an attribute of the cart item
                $('.cart-popup-item[data-hs-product-id=' + hsProductId + ']').attr('data-hs-line-item-id', lineItemId);
                $('.cart-payment-item[data-hs-product-id=' + hsProductId + ']').attr('data-hs-line-item-id', lineItemId);
			} else {
				callback(response);
			}
		});
	}

	Fw.component.export('hubspot', {
		REGEX_DOMAINS_TO_IGNORE,
		ACTION,
		TYPES,
		PIPELINES,
		ABANDONED_CART_URL,
		DEAL_NAME,
		isActive,
		addDeal,
		createLineItem,
		editLineItemQuantity,
		deleteLineItem,
		addAssociation,
		deleteAssociation,
		addContact,
		addFullContact,
		domainFromEmail,
		nameFromDomain,
		findContactByEmail,
		parseResToJSON,
		addContactToHubspot,
		editDealStage,
		editDealName,
		cancelHubspotDeal,
		createOrUpdateHubspotDeal,
		updateDealIdInSavedCart,
		addContactsToList,
		removeContactFromList,
		updateEmailSubscriptionToHubspotList,
		toggleOptInsHubspotByContactEmail,
		createLineItemAndAddToDeal,
	});

})(jQuery);
